export enum EOperators {
  LIKE = 'LIKE', // giống 1 phần giá trị
  LIKE_BEGIN = 'LIKE_BEGIN', // giống 1 phần giá trị
  EQ = 'EQ', // giống chính xác giá trị
  GE = 'GE', // lớn hơn hoặc bằng giá trị truyền vào
  LE = 'LE', // nhỏ hơn hoặc bằng giá trị truyền vào
  GT = 'GT', // lớn hơn giá trị truyền vào
  LT = 'LT', // nhỏ hơn giá trị truyền vào
  LIST = 'LIST', // thuộc danh sách giá trị truyền vào
  SEQ = 'SEQ', // giống giá trị truyền vào nếu bỏ các dấu cách
}
